import { useState, useEffect } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

import * as apiComms from '../apiComms';
import * as logger from '../logger';

const PROG = 'ChartCollectorCardsInProgressByStampNumber.js';
const IN_PROGRESS_STAMP_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8, 9];
const COLLECTOR_CARD_IDS = ['NADUR-2', 'NADUR-6', 'NADUR-12'];

const ChartCollectorCardsInProgressByStampNumber = (props) => {

  const [chartData, setChartData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    const loadChartData = async () => {
      const FUNCTION = 'loadChartData';

      try {
        setIsLoadingData(true);
        const _chartDataResponse = await apiComms.getChartDataCollectorCardsInProgressByStampNumber(props.timeRange);
        if (_chartDataResponse && !_chartDataResponse.isErr) {
          setChartData(normaliseChartData(_chartDataResponse.response.chartdata));
        }
        setIsLoadingData(false);
      }
      catch (e) {
        logger.error('Exception Occured', { PROG, FUNCTION });
        console.log('Exception: '+e+', '+e.stack);
      }
    };

    loadChartData();
  }, [props.timeRange]);

  const normaliseChartData = (rawChartData) => {
    const chartDataByStampNumber = {};

    if (Array.isArray(rawChartData)) {
      rawChartData.forEach((chartDataRec) => {
        const stampNumber = Number(chartDataRec.stampNumber);
        if (!IN_PROGRESS_STAMP_NUMBERS.includes(stampNumber)) {
          return;
        }

        chartDataByStampNumber[stampNumber] = {
          ...chartDataRec,
          stampNumber
        };
      });
    }

    return IN_PROGRESS_STAMP_NUMBERS.map((stampNumber) => {
      const chartDataRec = chartDataByStampNumber[stampNumber] ?? {};
      const normalisedRec = {
        stampNumber
      };

      COLLECTOR_CARD_IDS.forEach((collectorCardId) => {
        normalisedRec[collectorCardId] = Number(chartDataRec[collectorCardId] ?? 0);
      });

      return normalisedRec;
    });
  };

  return (
    <div className='card'>
      <div style={{ display : 'flex', width : '100%', flexDirection : 'column', borderRadius: 10, overflow : 'hidden' }} >
        <div style={{ height : 300 }}>
          {!isLoadingData ? (
            <>
            {Array.isArray(chartData) && chartData.length > 0 ? (
            <ResponsiveContainer>
              <BarChart data={chartData} margin={{ top: 20, right: 20, left: 6, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="stampNumber" label={{ value: 'Current Stamp Number', position: 'insideBottom', offset: -2 }} />
                <YAxis width={42} />
                <Tooltip />
                <Legend />
                <Bar dataKey="NADUR-2" stackId="a" fill="#369fe3" />
                <Bar dataKey="NADUR-6" stackId="a" fill="#20c997" />
                <Bar dataKey="NADUR-12" stackId="a" fill="#f59f00" />
              </BarChart>
            </ResponsiveContainer>
            ) : null }
            </>
          ) : null }
        </div>
        <div className='card-body'>
          Cards In Progress By Stamp Number
        </div>
      </div>
    </div>
  );
};

export default ChartCollectorCardsInProgressByStampNumber;
